var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"busyness-row",attrs:{"gutter":16}},[_c('a-col',{staticStyle:{"margin-bottom":"18px"},attrs:{"span":12}},[_c('div',{staticClass:"busyness-card"},[_c('a-statistic',{staticClass:"busyStatistic",attrs:{"title":"全部","value":_vm.total,"value-style":{
          fontSize: '32px',
          fontWeight: 500,
          color: '#6f42ff'
        }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"18px"},attrs:{"span":12}},[_c('div',{staticClass:"busyness-card busyness-card_normal"},[_c('a-statistic',{staticClass:"busyStatistic",attrs:{"title":"正常","value":_vm.dataSource.normal,"value-style":{
          fontSize: '32px',
          fontWeight: 500,
          color: '#51a8f2'
        }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"18px"},attrs:{"span":12}},[_c('div',{staticClass:"busyness-card busyness-card_busy"},[_c('a-statistic',{staticClass:"busyStatistic",attrs:{"title":"繁忙","value":_vm.dataSource.busy,"value-style":{
          fontSize: '32px',
          fontWeight: 500,
          color: '#fa8c16'
        }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"18px"},attrs:{"span":12}},[_c('div',{staticClass:"busyness-card busyness-card_idle"},[_c('a-statistic',{staticClass:"busyStatistic",attrs:{"title":"空闲","value":_vm.dataSource.idle,"value-style":{
          fontSize: '32px',
          fontWeight: 500,
          color: '#43B94D'
        }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }